function Footer({ children }) {
  return (
    <div className="bg-warning d-flex align-items-center pt-1 pb-1 justify-content-around">
      {children}
    </div>
  );
}

export default Footer;
